export default {"src":"/_next/static/media/clock-icon-new.e2bd3dff.svg","height":18,"width":18};